import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { BrandModel } from '../../models/brand.model';
import { getBrandsSelector } from '../../store/selectors/get-brands/get-brands.selector';
import { getBrands } from '../../thunk/get-brands.thunk';

export const useGetBrands = (): BrandModel[] => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getBrands());
  }, []);

  return useAppSelector(getBrandsSelector);
};
